import One from '../components/days/One';
import Two from '../components/days/Two';
import Three from '../components/days/Three';
import Four from '../components/days/Four';
import Five from '../components/days/Five';
import Six from '../components/days/Six';
import Seven from '../components/days/Seven';
import Eight from '../components/days/Eight';
import Nine from '../components/days/Nine';
import Ten from '../components/days/Ten';
import Eleven from '../components/days/Eleven';
import Twelve from '../components/days/Twelve';
import Thirteen from '../components/days/Thirteen';
import Fourteen from '../components/days/Fourteen';
import Fifteen from '../components/days/Fifteen';
import Sixteen from '../components/days/Sixteen';
import Seventeen from '../components/days/Seventeen';
import Eighteen from '../components/days/Eighteen';
import Nineteen from '../components/days/Nineteen';
import Twenty from '../components/days/Twenty';
import TwentyOne from '../components/days/TwentyOne';
import TwentyTwo from '../components/days/TwentyTwo';
import TwentyThree from '../components/days/TwentyThree';
import TwentyFour from '../components/days/TwentyFour';
import TwentyFive from '../components/days/TwentyFive';

import { PostType } from './PostType';
import { DaysProps } from '../components/Day';

const DaysData: DaysProps[] = [
  {
    preview: One,
    link: '%EF%B8%8F-121-bash-alias-for-iso-8601-formatted-time',
    type: PostType.FIX,
    title: 'Bash alias for ISO 8601 formatted time',
  },
  {
    preview: Two,
    link: '-122-animate-svg-hamburger-menu-to-x',
    type: PostType.CREATION,
    title: 'Animate SVG hamburger menu to X',
  },
  {
    preview: Three,
    link: '%EF%B8%8F-123-vscode-snippets',
    type: PostType.FIX,
    title: 'VSCode snippets',
  },
  {
    preview: Four,
    link: '-124-leetcoding-in-julia',
    type: PostType.NEW,
    title: 'Leetcoding in Julia',
  },
  {
    preview: Five,
    link: '%EF%B8%8F-125-auto-generate-prettier-config',
    type: PostType.FIX,
    title: 'Auto generate Prettier config',
  },
  {
    preview: Six,
    link: '-126-slack-logo-with-css-grid',
    type: PostType.NEW,
    title: 'Slack logo with CSS Grid',
  },
  {
    preview: Seven,
    link: '-127-skeleton-screens--new-preview-pic',
    type: PostType.CREATION,
    title: 'Skeleton screens + New preview pic',
  },
  {
    preview: Eight,
    link: '-128-intro-to-neural-networks',
    type: PostType.NEW,
    title: 'Intro to neural networks',
  },
  {
    preview: Nine,
    link: '-129-spotify-wrapped-design-analysis',
    type: PostType.OPINION,
    title: 'Spotify Wrapped design analysis',
  },
  {
    preview: Ten,
    link: '-1210-github-wrapped',
    type: PostType.CREATION,
    title: 'GitHub Wrapped',
  },
  {
    preview: Eleven,
    link: '-1211-back-to-top-button-1',
    type: PostType.CREATION,
    title: 'Back to top button (1)',
  },
  {
    preview: Twelve,
    link: '%EF%B8%8F-1212-back-to-top-button-2',
    type: PostType.FIX,
    title: 'Back to top button (2)',
  },
  {
    preview: Thirteen,
    link: '%EF%B8%8F-1213-gatsby-plugin-to-calculate-reading-time',
    type: PostType.FIX,
    title: 'Gatsby plugin to calculate reading time',
  },
  {
    preview: Fourteen,
    link: '-1214-github-dark-mode-is-too-dark',
    type: PostType.OPINION,
    title: 'GitHub dark mode is too dark',
  },
  {
    preview: Fifteen,
    link: '-1215-styled-components',
    type: PostType.NEW,
    title: 'styled-components',
  },
  {
    preview: Sixteen,
    link: '%EF%B8%8F-1216-vscode-spell-check',
    type: PostType.FIX,
    title: 'VSCode spell check',
  },
  {
    preview: Seventeen,
    link: '-1217-round-profile-pics',
    type: PostType.OPINION,
    title: 'Round profile pics',
  },
  {
    preview: Eighteen,
    link: '-1218-react-native',
    type: PostType.NEW,
    title: 'React Native',
  },
  {
    preview: Nineteen,
    link: '-1219-karenyingcom-redesign-1',
    type: PostType.CREATION,
    title: 'karenying.com redesign (1)',
  },
  {
    preview: Twenty,
    link: '-1220-karenyingcom-redesign-2',
    type: PostType.CREATION,
    title: 'karenying.com redesign (2)',
  },
  {
    preview: TwentyOne,
    link: '%EF%B8%8F-1221-progressive-image-loader',
    type: PostType.FIX,
    title: 'Progressive image loader',
  },
  {
    preview: TwentyTwo,
    link: '-1222-quarantine-running-recap',
    type: PostType.CREATION,
    title: 'Quarantine running recap',
  },
  {
    preview: TwentyThree,
    link: '-1223-react-redux',
    type: PostType.NEW,
    title: 'React Redux',
  },
  {
    preview: TwentyFour,
    link: '%EF%B8%8F-1224-keyboard-shortcuts',
    type: PostType.FIX,
    title: 'Keyboard shortcuts',
  },
  {
    preview: TwentyFive,
    link: '-1225-finale',
    type: PostType.CONFETTI,
    title: 'Finale',
  },
];

export default DaysData;
